import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { UnidadeMedidaEnum } from "core/features/orcamento/typings";

const { Option } = Select;

export interface SelectMedidaProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectMedida({ value, ...rest }: SelectMedidaProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option value={UnidadeMedidaEnum.Unidade} key={UnidadeMedidaEnum.Unidade}>
        Unidade
      </Option>
      <Option value={UnidadeMedidaEnum.Caixa} key={UnidadeMedidaEnum.Caixa}>
        Caixa
      </Option>
      <Option value={UnidadeMedidaEnum.Metro} key={UnidadeMedidaEnum.Metro}>
        Metros
      </Option>
      <Option
        value={UnidadeMedidaEnum.MetroQuadrado}
        key={UnidadeMedidaEnum.MetroQuadrado}
      >
        Metros quadrados
      </Option>
      <Option
        value={UnidadeMedidaEnum.MetroCubico}
        key={UnidadeMedidaEnum.MetroCubico}
      >
        Metros cúbicos
      </Option>
      <Option value={UnidadeMedidaEnum.Quilo} key={UnidadeMedidaEnum.Quilo}>
        Quilo
      </Option>
      <Option value={UnidadeMedidaEnum.Grama} key={UnidadeMedidaEnum.Grama}>
        Grama
      </Option>
      <Option value={UnidadeMedidaEnum.Litro} key={UnidadeMedidaEnum.Litro}>
        Litro
      </Option>
      <Option value={UnidadeMedidaEnum.Minuto} key={UnidadeMedidaEnum.Minuto}>
        Minuto
      </Option>
      <Option value={UnidadeMedidaEnum.Hora} key={UnidadeMedidaEnum.Hora}>
        Hora
      </Option>
      <Option value={UnidadeMedidaEnum.Dia} key={UnidadeMedidaEnum.Dia}>
        Dia
      </Option>
      <Option value={UnidadeMedidaEnum.Mes} key={UnidadeMedidaEnum.Mes}>
        Mês
      </Option>
      <Option value={UnidadeMedidaEnum.Ano} key={UnidadeMedidaEnum.Ano}>
        Ano
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectMedida;
